// @tss-nocheck
import React from 'react';
import { FaLock, FaLockOpen, FaWrench, FaTrashAlt } from 'react-icons/fa';
import './DashboardCard.scss';

const PIN_FEATURE = true;

export interface DashboardCardProps {
  deleteHandler: (data: any) => any;
  onConfigItem: (data: any) => any;
  onPinItem: (data: any) => any;
  card: any;
  pinned: boolean;
}

const isPinFeatureEnabled = () => {
  return PIN_FEATURE;
};

/**
 * This layout demonstrates how to use a grid with a dynamic number of elements.
 */
const DashboardCard: React.FC<DashboardCardProps> = ({
  card,
  pinned = false,
  deleteHandler,
  onConfigItem,
  onPinItem,
}) => {
  const pinStyle: any = {
    position: 'absolute',
    left: '2px',
    bottom: 0,
    cursor: 'pointer',
  };
  const setupStyle: any = {
    position: 'absolute',
    left: '2px',
    top: 0,
    cursor: 'pointer',
  };
  const removeStyle: any = {
    position: 'absolute',
    right: '2px',
    top: 0,
    cursor: 'pointer',
  };

  if (!card) return <div></div>;
  const showName =
    typeof card.options !== 'undefined' &&
    typeof card.options.showName !== 'undefined'
      ? card.options.showName
      : true;

  return (
    <>
      <card.component
        data={card.data}
        options={card.options}
        sseUrl={card.sseUrl}
        security={card.security}
        view={card.view}
      />
      <span className="grid-control" style={setupStyle}>
        <FaWrench
          id="ctrl"
          onClick={event => {
            event.stopPropagation();
            onConfigItem({
              cardId: card.cardId,
              widgetId: card.widgetId,
            });
          }}
        />
      </span>
      {isPinFeatureEnabled() && (
        <span className="grid-control" style={pinStyle}>
          {!pinned && (
            <FaLockOpen
              id="ctrl"
              onClick={() => {
                onPinItem(card.cardId);
              }}
            />
          )}
          {pinned && (
            <FaLock
              id="ctrl"
              onClick={() => {
                onPinItem(card.cardId);
              }}
            />
          )}
        </span>
      )}

      {showName && (
        <span className="id-card-name">
          <p className="id-text-gray-800 id-text-center">{card.name}</p>
        </span>
      )}

      <span className="grid-control" style={removeStyle}>
        <FaTrashAlt
          id="ctrl-del"
          onClick={event => {
            event.stopPropagation();
            deleteHandler(card.cardId);
          }}
        />
      </span>
    </>
  );
};

export default React.memo(DashboardCard);
